import { createAction } from 'redux-actions'

export const clearMemberSession = createAction('CLEAR_MEMBER_SESSION')
export const setMemberSession = createAction('SET_MEMBER_SESSION')
